import React, { useEffect, useState } from "react";
import "./Pagination.css";

const Pagination = ({ rowsPerPage, totalRows, paginate, currentPage }: any) => {
  const [pageNumbersLsit, setPageNumbersLsit] = useState([]);
  const pageLimit = Math.ceil(totalRows / rowsPerPage);

  useEffect(() => {
    const pageNumbers: any = [];
    for (let i = 1; i <= pageLimit && pageNumbers.length < 5; i++) {
      pageNumbers.push(i);
    }
    setPageNumbersLsit(pageNumbers);
    paginate(1);
  }, [totalRows,rowsPerPage]);

  const nextPage = () => {
    if (currentPage + 1 <= pageLimit) {
      if (currentPage + 1 > pageNumbersLsit[4]) {
        const pageNumbers: any = [];
        for (
          let i = currentPage + 1;
          i <= pageLimit && pageNumbers.length < 5;
          i++
        ) {
          pageNumbers.push(i);
        }
        setPageNumbersLsit(pageNumbers);
      }
      paginate(currentPage + 1);
    }
  };
  const previousPage = () => {
    if (currentPage - 1 > 0) {
      if (currentPage - 1 < pageNumbersLsit[0]) {
        const pageNumbers: any = [];
        for (
          let i = currentPage - 1;
          i > 0 && pageNumbers.length < 5;
          i--
        ) {
          pageNumbers.push(i);
        }
        setPageNumbersLsit(pageNumbers.reverse());
      }

      paginate(currentPage - 1);
    }
  };

  return (
    <>
      <div className="pagination">
        <div className="prev-btn-section center-div">
          <div className="prev-btn center-div" onClick={() => previousPage()}>
            Previous
          </div>
        </div>

        <div className="page-list-section center-div">
          <ul className="page-list">
            {pageNumbersLsit.map((number) => (
              <li
                key={number}
                className={`page-item center-div  ${
                  currentPage === number ? "active-page-number" : ""
                }`}
                onClick={() => paginate(number)}
              >
                <div>{number}</div>
              </li>
            ))}
          </ul>
        </div>
        <div className="next-btn-section center-div">
          <div className="next-page-btn center-div" onClick={() => nextPage()}>
            Next
          </div>
        </div>
      </div>
    </>
  );
};

export default Pagination;
